import { gql } from "@apollo/client";

import TopicNodeFragment from "./topic-node-fragment";

export default gql`
  ${TopicNodeFragment}
  mutation addPreviousMeetingTopicsToCurrentMeetingMutation(
    $meetingId: Int!
    $position: String
  ) {
    addPreviousMeetingTopicsToCurrentMeeting(
      meetingId: $meetingId
      position: $position
    ) {
      meeting {
        id
        undiscussedPreviousMeetingTopics {
          id
          title
        }
        topics {
          edges {
            node {
              ...TopicNodeNewPageFragment
            }
          }
        }
      }
    }
  }
`;
